// extracted by mini-css-extract-plugin
module.exports = {"customer-picker":"customer-picker___1iH0z"};